import {
    Box,
    BoxedRow,
    BoxedRowList,
    ButtonFixedFooterLayout,
    ButtonLayout,
    ButtonLink,
    ButtonPrimary,
    Callout,
    Divider,
    IconChevronLeftRegular,
    IconInvoiceEuroRegular,
    IconInformationUserRegular,
    InfoFeedbackScreen,
    NavigationBar,
    Spinner,
    Text2,
    ThemeVariant,
    skinVars,
    Circle,
    Text5,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDebtDetail, generateGCOPaymentUrl } from '../../../services/BillService';
import { hideSpinner, showSpinner, showStopper } from '../../../utils/store/features/user';
import { useDispatch } from 'react-redux';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import BreadCrumbsWrapper from '../../../components/BreadcrumbsWrapper';
import { managementEnvironment } from '../../../utils/dataTransformation/environments';

const ModalDebtPayment: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [showCallOut, setshowCallOut] = useState<boolean | null>(null);

    const billsPaymentDisabled = managementEnvironment().VITE_STOPPER_BILL_PAYMENT_DISABLED;

    useEffect(() => {
        const fetchDebtDetail = async () => {
            try {
                dispatch(showSpinner());
                const response: any = await getDebtDetail();
                setshowCallOut(response.data);
            } finally {
                dispatch(hideSpinner());
                setLoading(false);
            }
        };

        fetchDebtDetail();
    }, []);
    const storage = localStorage.getItem('storage');
    let storageJson: any;
    if (storage) {
        storageJson = JSON.parse(storage);
    }
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        dispatch(showSpinner());
    }, []);

    const sendToGCO = (url: string, webviewUrl: any, callBackUrl: any) => {
        navigate(url + `?callBackUrl=${callBackUrl}` + `&webviewUrl=${webviewUrl}`);
    };

    const gcoFlow = () => {
        if (billsPaymentDisabled) {
            dispatch(showStopper());
        } else {
            dispatch(showSpinner());
            generateGCOPaymentUrl()
                .then((response: any) => {
                    const webviewUrl = response?.data?.webViewUrl;
                    const callBackUrl = response?.data?.callBackUrl;
                    dispatch(hideSpinner());
                    sendToGCO('/bills/gco-flow', webviewUrl, callBackUrl);
                })
                .catch(() => {
                    dispatch(showSpinner());
                });
        }
    };

    const printDebtPayment: any = () => {
        return storageJson.pendingBills ? (
            <div className='DebtPayment-page'>
                <div
                    className='DebtPayment-page__header'
                    style={{
                        background: skinVars.colors.background,
                    }}
                >
                    {!(isWebviewAndroid || isWebviewIOS) && (
                        <>
                            <div className='DebtPayment-page__header-navigationBar'>
                                <NavigationBar
                                    withBorder={false}
                                    title={t('PaymentdebtModalHeader')}
                                    onBack={() => {
                                        navigate('/bills');
                                    }}
                                />
                            </div>
                            <div className='DebtPayment-page__header-return'>
                                <div
                                    className='DebtPayment-page__header-return-cursor'
                                    onClick={() => {
                                        navigate('/bills');
                                    }}
                                >
                                    <div className='DebtPayment-page__header-return-icon'>
                                        <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                                    </div>
                                    <Text2 medium color={skinVars.colors.textPrimary}>
                                        {t('returnResponsive')}
                                    </Text2>
                                </div>
                            </div>
                        </>
                    )}

                    <div className='DebtPayment-page__header-breadcrumbs'>
                        <ThemeVariant>
                            <BreadCrumbsWrapper
                                title={t('PaymentdebtModalHeader')}
                                breadcrumbs={[{ title: t('invoice'), url: '/bills' }]}
                            />
                        </ThemeVariant>
                    </div>
                </div>
                <div className='DebtPayment-page__divider'>
                    <Divider />
                </div>
                <div className='DebtPayment-page__body'>
                    <div className='DebtPayment-page__title'>
                        <Text5 color={skinVars.colors.textPrimary}>{t('debtPaymentPageTitle')}</Text5>
                    </div>

                    <div className='DebtPayment-page__products'>
                        <BoxedRowList>
                            <Box>
                                <BoxedRow
                                    asset={
                                        <Circle backgroundColor={skinVars.colors.errorLow} size={40}>
                                            <IconInvoiceEuroRegular size={24} color={skinVars.colors.error} />
                                        </Circle>
                                    }
                                    title={t('modalDebtPaymentPendingBills')}
                                    description={t('modalDebtPaymentPendingBillsDescription')}
                                    extra={
                                        <ButtonPrimary
                                            onPress={() => {
                                                gcoFlow();
                                            }}
                                            style={{ marginTop: '10px', padding: '0px', fontSize: '34px' }}
                                            small={true}
                                        >
                                            {t('debtPaymentReviewButton')}
                                        </ButtonPrimary>
                                    }
                                />
                            </Box>
                        </BoxedRowList>
                    </div>
                    {showCallOut && (
                        <div className='DebtPayment-page__callout'>
                            <Callout
                                asset={<IconInformationUserRegular color={skinVars.colors.brand} size={24} />}
                                title={t('debtRehabilitationCardTitle')}
                                description={t('debtRehabilitationCardDescription')}
                                buttonLink={
                                    <ButtonLink
                                        onPress={() => {
                                            navigate('/modal-debt-payment/modal-rehabilitation-lines');
                                        }}
                                    >
                                        {t('debtRehabilitationMoreInfoLink')}
                                    </ButtonLink>
                                }
                            />
                        </div>
                    )}
                </div>
            </div>
        ) : (
            <div>
                <InfoFeedbackScreen
                    title={t('modalDebtPaymentFeedbackTitle')}
                    description={t('modalDebtPaymentFeedbackDescription')}
                    primaryButton={
                        <ButtonFixedFooterLayout>
                            <ButtonLayout
                                align='full-width'
                                primaryButton={
                                    <ButtonPrimary onPress={() => {}}>{t('buttonUnderstoodFeedback')}</ButtonPrimary>
                                }
                            />
                        </ButtonFixedFooterLayout>
                    }
                ></InfoFeedbackScreen>
            </div>
        );
    };

    return <div className='DebtPayment-page'>{loading ? <Spinner size={24} /> : printDebtPayment()}</div>;
};

export default ModalDebtPayment;
